import { GETALLMATCHES, GETCONTESTLIST, GETCOMPLITEMATCHLIST, GETCURRENTUPCOMINGMATCH, GETLIVEMATCHBOOK, GETLIVEMATCHLIST, GETMATCHPLAYERS, GETSCHEDULE, GETUSERTEAMDETAILS, SAVE_SCHEDULE, SAVECONTEST, SAVEPLAYERSCREDIT, SETFNRESULT, SETFNRESULTROLLBACK } from './url'
import axios from 'axios';

class FantacyMatchServiceClass {

    async getScheduleService() {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`
        };
        return await axios.get(`${GETSCHEDULE}`, {
            headers: headers,
        });
    }

    async postSaveScheduleService(data) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`
        };
        return await axios.post(`${SAVE_SCHEDULE}`, data, {
            headers: headers,
        });
    }

    async postSavePlayersCreditService(data) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`
        };
        return await axios.post(`${SAVEPLAYERSCREDIT}`, data, {
            headers: headers,
        });
    }

    async getUpcomingListService() {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`
        };
        return await axios.get(`${GETCURRENTUPCOMINGMATCH}`, {
            headers: headers,
        });
    }

    async getMatchPlayers(matchId) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`
        };
        return await axios.get(`${GETMATCHPLAYERS}/${matchId}`, {
            headers: headers,
        });
    }

    async getAllMatchesService() {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`
        };
        return await axios.get(`${GETALLMATCHES}`, {
            headers: headers,
        });
    }

    async getContestListService() {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`
        };
        return await axios.get(`${GETCONTESTLIST}`, {
            headers: headers,
        });
    }

    async postCreateContestService(data) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`
        };
        return await axios.post(`${SAVECONTEST}`, data, {
            headers: headers,
        });
    }

    async getLiveMatchListService() {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`
        };
        return await axios.get(`${GETLIVEMATCHLIST}`, {
            headers: headers,
        });
    }

    async getLiveMatchBookService(matchId) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`
        };
        return await axios.get(`${GETLIVEMATCHBOOK}?matchId=${matchId}`, {
            headers: headers,
        });
    }

    async getCompliteMatchListService() {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`
        };
        return await axios.get(`${GETCOMPLITEMATCHLIST}`, {
            headers: headers,
        });
    }

    async setFnResultService(matchId) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`
        };
        return await axios.get(`${SETFNRESULT}?matchId=${matchId}`, {
            headers: headers,
        });
    }

    async setFnResultRollbackService(matchId) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`
        };
        return await axios.get(`${SETFNRESULTROLLBACK}?matchId=${matchId}`, {
            headers: headers,
        });
    }

    async getUserTeamDetailsService(teamId, matchId) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`
        };
        return await axios.get(`${GETUSERTEAMDETAILS}?teamId=${teamId}&matchId=${matchId}`, {
            headers: headers,
        });
    }

}

const FantacyMatchService = new FantacyMatchServiceClass()

export default FantacyMatchService;